import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { ProjectPermissionDto } from 'projects/shared/src/lib/models/PermissionForCreationDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { PermissionsService } from 'projects/shared/src/lib/services/permissions.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'app-add-project-grouprole-dialog',
  templateUrl: './add-project-grouprole-dialog.component.html',
  styleUrls: ['./add-project-grouprole-dialog.component.css']
})
export class AddProjectGrouproleDialogComponent implements OnInit {

  projectPermissions: ProjectPermissionDto[] = [];
  groupRoleForm!: FormGroup;
  toDisplay = false;
  titleAlert: string = 'This field is required';


  constructor(
    private formBuilder: FormBuilder,
    public _dialogRef: MatDialogRef<AddProjectGrouproleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    private permissionService: PermissionsService,
    private oauthService: OAuthServiceService

  ) {

  }
   ngOnInit(): void {
      // all possible permissions
      this.permissionService.loadProjectPermissions(this.tenantService.currentTenantName, new GenericFilter()).subscribe({
        next:(permissionDtos:any) => { 
          this.projectPermissions = permissionDtos;
          console.log("-------> ProjPerm = ", this.projectPermissions)
          this.toDisplay = true;
          this.createUserForm();
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADEDERROR"]}`)
      })
  }
  createUserForm() {
    this.groupRoleForm = this.formBuilder.group({
      name: [null, Validators.required],
      permissions: ['']
    });
  }

  onChange(permissions: string) {
    this.groupRoleForm.get('permissions')!.setValue(permissions);
  }
  cancel() {
    this._dialogRef.close();
  }

  add() {
    if (this.groupRoleForm.valid) {
      console.log(this.groupRoleForm.value)
      this._dialogRef.close(this.groupRoleForm.value);
    }
    else{
      this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["USERREQUIREDFIELDS"]}`);
    }
  }
}

